var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6293 19.119L15.2931 13.7828C17.9015 10.4312 17.6654 5.58305 14.5847 2.50234C11.2482 -0.834112 5.83879 -0.834112 2.50234 2.50234C-0.834112 5.83879 -0.834112 11.2482 2.50234 14.5847C5.58305 17.6654 10.4312 17.9015 13.7828 15.2931L19.119 20.6293C19.5266 21.0369 20.2088 21.0429 20.6259 20.6259C21.0458 20.2059 21.0445 19.5342 20.6293 19.119ZM13.0744 4.01263C15.5767 6.51497 15.5767 10.5721 13.0744 13.0744C10.5721 15.5767 6.51497 15.5767 4.01263 13.0744C1.51029 10.5721 1.51029 6.51497 4.01263 4.01263C6.51497 1.51029 10.5721 1.51029 13.0744 4.01263Z",
    transform: "translate(0.1331182 0.1329432)",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/Search-icon.38abc3e6a7b3e4bc449f204edb1c63c5.svg";
export { ForwardRef as ReactComponent };